import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';
import { Router } from 'aurelia-router';
import { TableHeader } from 'components/table/table-content';
import { Filters } from 'elements/Filter';
import { DataFilter } from 'lib/tables/DataFilter';
import { FilterManager } from 'lib/tables/FilterManager';
import { AsyncErrorHandler } from 'lib/ui';
import { PenOrderListItemDto } from 'models/pen/PenOrder';
import { PenOrderService } from 'services/pen/pen-order-service';

type TableFilter = {} & DataFilter;

@autoinject
export class PensOrdersView {
  protected penOrders: PenOrderListItemDto[] = [];

  //TODO, change any type when the right type is rdy
  protected tableHeaders: TableHeader<PenOrderListItemDto>[] = [
    { key: 'CustomerName', label: 'general.customer', sortable: true },
    { key: 'PenOrderNumber', label: 'general.ordernr', sortable: true },
    { key: 'PenOfferNumber', label: 'generalOffer.QuoteNumber', sortable: true },
    { key: 'NumberOfPens', label: 'order.numberOfNets', sortable: true },
    { key: 'PorducerName', label: 'general.producer', sortable: true },
  ];

  constructor(private t: I18N, protected fm: FilterManager, private router: Router, private penOrderService: PenOrderService) {}

  protected async attached() {
    this.fm.paginationTotalRecords = 0;
    await this.load();

    this.fm.init({
      context: 'pens-orders',
      storageKey: 'pens-orders',
      filters: {
        //Add filters
      } satisfies Filters,
      defaultFilters: {
        //Add default filters
      },
    });

    await this.getOrders();
  }

  private async load() {
    //Load options for dropwdowns in filters
  }

  @AsyncErrorHandler
  async getOrders() {
    const { data, headers } = await this.penOrderService.getOrders(this.fm.queryFilter);
    const record = headers.get('x-total-count');
    this.fm.paginationTotalRecords = record ? +record : 0;
    this.penOrders = data;
  }

  protected openOrder(penorderId: number, penId: number) {
    this.router.navigate(`pen-order/${penorderId}/pen/${penId}`);
  }
}
